import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface ISubtitle2Prop {
  children: string
}
// default body text
export const Subtitle2 = ({
  children,
  ...props
}: TypographyProps & ISubtitle2Prop) => (
  <Typography variant="subtitle2" {...props}>
    {children}
  </Typography>
)
